import React from 'react';

function TermsNConditions() {
  return <div>TermsNConditions</div>;
}

export default TermsNConditions;
